import ModelActionsService from 'services/storageModelActions/ModelActionsService';
import { PATH_BACKEND } from 'configs/routes/pathsBackend';
import { OrderReportConfigResponseDTO } from 'typings/dto/orderReport';
import IOrderReportConfigActionsService from 'services/storageModelActions/orderReportConfig/IOrderReportConfigActionsService';
import NavigateFrontendUtils from 'utils/NavigateFrontend';

export default class OrderReportConfigActionsServiceImpl
  extends ModelActionsService<OrderReportConfig, never, OrderReportConfigResponseDTO>
  implements IOrderReportConfigActionsService
{
  /** @throws `BackendResponseError` */
  public getValuesFromOrderForFilter = (): Promise<void> => {
    const url = PATH_BACKEND.orderReportConfig.orderFilter;
    const lso = NavigateFrontendUtils.getLocationSearchObjectFromCurrentLocation();
    const active = lso.active;
    const archiveYear = lso.archiveYear;
    return this.getAllForFilter(undefined, { active, archiveYear }, url);
  };
}
